<template>
    <b-card no-body class="w-100 mx-2">
        <b-row class="no-gutters" @click="ShowFooterEvent()" style="cursor: pointer;">
            <b-col class="p-2 bg-gray-light rounded d-flex border-bottom">
                <div class="my-auto d-flex">
                    <div style="font-size: 1rem; font-weight: 600;">{{ $t('SubMeter') }}</div>
                    <div v-if="countUnderMeter(Sections) > 0" class="ml-1" style="font-size: 0.625rem; font-weight: 500;">({{ countUnderMeter(Sections) }})</div>
                </div>
                <b-button size="sm" class="btn-circle bg-white border-gray text-black position-absolute" style="right: 2%; top: 10%;">
                    <b-icon v-if="ShowFooter" icon="chevron-down" scale="1.7"/>
                    <b-icon v-else icon="chevron-up" scale="1.7"/>
                </b-button>
            </b-col>
        </b-row>
        
        <AllocationPeriods v-if="ShowFooter" :Sections="Sections" :IndexWidth.sync="IndexWidth" :AllocationUtils="allocationUtils" :CheckWriteAction="CheckWriteAction" :CheckDeleteAction="CheckDeleteAction" @AddSectionEvent="AddSectionEvent" @SectionSelectedEvent="SectionSelectedEvent" @SectionDeletedEvent="SectionDeletedEvent" />

        <b-row v-if="ShowFooter" class="w-100 my-auto px-2 no-gutters">
            <b-col class="d-flex">
                <b-button class="btn-circle my-auto bg-white border-gray text-black m-2" style="z-index: 2;" :style="!showArrow ? 'opacity: 0; pointer-events: none' : meterList[0]?.key == 0 ? 'opacity: .65; pointer-events: none;' : ''" @click="getChildMeter(-1);" >
                    <b-icon icon="chevron-left" scale="0.95"/>
                </b-button>
                <div v-for="(child, index) in meterList" :key="index" style="width: 13.5rem;" class="d-flex flex-column justify-content-center mx-1">
                    <div class="bg-white border border-gray px-0 py-2 d-flex rounded" style="z-index: 2;"
                        role="button" @click="showChangeCurrentMeter(child.value)">
                        <div class="d-flex align-items-center h-100 w-100">
                            <b-img class="mx-1" style="height: 1.15rem; width: 1rem;" :src="AbsoluteLink(child.value.Icon)" />
                            <div class="w-100 text-truncate mx-1 d-flex">
                                <span class="font-weight-bold text-truncate text-black" style="font-size: .75rem" v-b-tooltip.hover :title="child.value.Name">{{ child.value.Name }}</span>
                            </div>
                            <div class="text-left my-auto px-1">
                                <b-icon icon="x" scale="1.5" style="color: #DC3545;" @click.stop="DeleteUnderMeterEvent(child.value.Id)" />
                            </div>
                        </div>
                    </div>
                </div>
                <b-button class="ml-2 my-auto d-flex text-truncate" :variant="'outline-' + Variant" pill style="z-index: 2;" @click="OpenTreeNodesEvent('under');">
                    <b-icon icon="plus" class="my-auto" scale="1" />
                    <div class="my-auto text-right" style="font-size: 0.75rem;">{{ $t('AddSubMeter') }}</div>
                </b-button>
                <b-button class="btn-circle my-auto bg-white border-gray text-black position-absolute" :style="!showArrow ? 'opacity: 0; pointer-events: none' : meterList[meterList.length - 1]?.key == countUnderMeter(Sections.filter(u => u.Value?.Selected == true)) - 1 ? 'opacity: .65; pointer-events: none;' : ''" style="z-index: 2; right: 0.5rem; top: 50%; transform: translateY(-50%);" @click="getChildMeter(1);">
                    <b-icon icon="chevron-right" scale="0.95"/>
                </b-button>
            </b-col>
        </b-row>

        <b-modal id="modal" size="md" v-model="showChangeMeter.key" hide-header centered no-close-on-backdrop no-close-on-esc>
            <template>
                <div class="h-100 w-100">
                    <h5 class="modal-title text-center w-100 font-weight-bold">{{ $t('AccessMeter', {meterName: showChangeMeter.value?.Name}) }}</h5>
                </div>
            </template>
            <template #modal-footer>
                <b-button @click="changeCurrentMeter(false)" :variant="'outline-' + Variant" pill>{{$t('Cancel')}}</b-button>
                <b-button @click="changeCurrentMeter(true)" :variant="Variant" pill>{{$t('Submit')}}</b-button>
            </template>
        </b-modal>
    </b-card>
</template>

<script lang="ts">
    import { mixins } from 'vue-class-component';
    import { Prop, Component, Watch } from 'vue-property-decorator';
    import { Getter } from 'vuex-class';
    import TreeNode from '@/types/TreeNode';
    import { MAIN_FILTER_TREE } from "@/App.settings";
    import locales from "../locales/Allocation.json";
    import { LinkUtils } from '@/components/commons/Utils';
    import 'vue-cute-timeline/dist/index.css';
    import FormDraft from "@/types/fields/FormDraft";
    import Section from '@/types/fields/Section';
    import Dictionary from '@/types/Dictionary';
    import IField from '@/interfaces/IField';
    import FieldTypeEnum from '@/enums/fields/FieldTypeEnum';
    import Period from '@/types/Period';
    import HscMenuStyleCustom from '@/components/commons/HscMenuStyleCustom';
    import { BaseObjectForm } from '../BaseObjectForm';
    import GraphNode from '@/types/fields/GraphNode';
    import AllocationUtils from './AllocationUtils';
    import AllocationPeriods from './AllocationPeriods.vue';

    @Component({
        components: {
            AllocationPeriods,
            'hsc-menu-style-custom': HscMenuStyleCustom("secondary"),
        },
        i18n: { messages: locales }
    })
    export default class AllocationFooter extends mixins(LinkUtils, BaseObjectForm<FormDraft<Section<Period, Dictionary<IField[]>>>>) 
    {
        @Prop()
        public Sections!: Section<Period, Dictionary<IField[]>>[];

        @Prop()
        public IndexWidth!: number;

        @Prop()
        public AllocationUtils!: AllocationUtils;

        @Prop()
        public ShowFooter!: boolean;

        @Prop()
        public CheckWriteAction!: boolean;

        @Prop()
        public CheckDeleteAction!: boolean;

        @Getter('ObjectStore/GetUpdatedForms')
        private updatedForms!: string[];

        private allocationUtils: AllocationUtils = {} as AllocationUtils;

        private showChangeMeter: { key: boolean, value: TreeNode } = {key: false, value: null};
        private meterList: { key: number, value: TreeNode }[] = [];
        private showArrow: boolean = false;

        @Watch('IndexWidth')
        @Watch('Sections', { deep: true })
        private callGetChildMeter() : void 
        {
            this.getChildMeter();
        }

        private getChildMeter(index?: number) : void 
        {
            let _sectionStart: number = 0;
            let _indexWidth: number = this.IndexWidth - 1;
            this.showArrow = false;

            if(this.Sections?.filter(u => u.Fields != undefined && u.Value != undefined).length > 0)
            {
                let TreeNode: TreeNode[] = this.Sections?.filter(u => u.Value?.Selected == true)[0]?.Fields[nodesField].map(u => 
                {
                    return this.$store.getters[MAIN_FILTER_TREE + "/Node"]((u as GraphNode).Id) as TreeNode;
                });

                if(TreeNode == undefined || TreeNode.length == 0)
                {
                    this.meterList = [];
                    return;
                }

                if(TreeNode?.length > _indexWidth)
                {
                    this.showArrow = true;

                    if(index != undefined && this.meterList.length > 0)
                    {                        
                        let minIndex: number = this.meterList.map(y => y.key).reduce((a, b) => Math.min(a, b));
                        let maxIndex: number = this.meterList.map(y => y.key).reduce((a, b) => Math.max(a, b));

                        _sectionStart = minIndex;

                        if(minIndex + index >= 0 && maxIndex + index < TreeNode.length)
                            _sectionStart += index;    
                    }
                }

                this.meterList = [];
                for(let i = _sectionStart; i < _sectionStart + _indexWidth; i++)
                {
                    if(TreeNode[i])
                        this.meterList.push( { key: i, value: TreeNode[i] } );
                }
            }
        }

        private countUnderMeter(sections: Section<Period, Dictionary<IField[]>>[]) : number
        {
            return sections?.map(u => u.Fields[nodesField]).flat().length || 0;
        }

        private showChangeCurrentMeter(node: TreeNode) : void
        {
            if(this.updatedForms.filter(u => u == "Allocation").length == 0)
            {
                this.showChangeMeter = {key: false, value: node};
                this.changeCurrentMeter(true);
            }
            else
                this.showChangeMeter = {key: true, value: node};
        }

        private OpenTreeNodesEvent(option: string) : void 
        {
            this.$emit("OpenTreeNodesEvent", option);
        }

        private changeCurrentMeter(valid: boolean) : void
        {
            if(valid)
                this.$store.dispatch(MAIN_FILTER_TREE +  "/SelectNode", { node: this.showChangeMeter.value, openNode: true, scrollIntoView: true });

            this.showChangeMeter = {key: false, value: null};
        }

        private DeleteUnderMeterEvent(underMeterId: string) : void 
        {
            this.$emit("DeleteUnderMeterEvent", underMeterId);
        }

        private AddSectionEvent(sections: Section<Period, Dictionary<IField[]>>[]) : void 
        {
            this.$emit("AddSectionEvent", sections);
        }

        private SectionSelectedEvent(index: number) : void 
        {
            this.$emit("SectionSelectedEvent", index);
        }

        private SectionDeletedEvent(index: number, sections: Section<Period, Dictionary<IField[]>>[]) : void 
        {
            this.$emit('SectionDeletedEvent', index, sections)
        }

        private ShowFooterEvent() : void {
            this.$emit("ShowFooterEvent");
        }

        created() 
        {
            this.allocationUtils = new AllocationUtils(this.$i18n);
        }
    }

    /** Clé du dictionnaire des Fields contenant les Nodes */
    const nodesField: string = FieldTypeEnum[FieldTypeEnum.Node].toString();

</script>

<style>
</style>